var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2014_48133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.51831 7.77783C1.51831 11.3576 4.42031 14.2596 8.00012 14.2596C11.5799 14.2596 14.4819 11.3576 14.4819 7.77783C14.4819 4.19803 11.5799 1.29602 8.00012 1.29602C4.42031 1.29602 1.51831 4.19803 1.51831 7.77783Z",
    fill: "white",
    stroke: "#383538",
    strokeWidth: 1.29636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94482 9.72274L6.05574 5.83365",
    stroke: "#383538",
    strokeWidth: 1.29636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.05574 9.72275L9.94482 5.83366",
    stroke: "#383538",
    strokeWidth: 1.29636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2014_48133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.5564,
    height: 15.5564,
    fill: "white",
    transform: "translate(15.7783) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.0e6c6eb24a7c0844f5b32eeb36428517.svg";
export { ForwardRef as ReactComponent };